<template>
  <div class="OverlayToggle"
    :class="classes">

    <p class="OverlayToggle-label"
      v-text="label">
    </p>

    <icon class="OverlayToggle-icon"
      name="plus"
      width="11px"
      height="11px"
      :style="iconStyles" />

  </div>
</template>

<script>
export default {
  name: 'OverlayToggle',

  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    inactiveLabel: {
      type: String
    },
    activeLabel: {
      type: String,
      default: 'Close'
    }
  },

  computed: {
    /**
     * Classes for the main element
     * @return {Object}
     */
    classes () {
      return {
        'OverlayToggle--isActive': this.isActive
      }
    },

    /**
     * Label text
     * @return {String}
     */
    label () {
      return this.isActive ? this.activeLabel : this.inactiveLabel
    },

    /**
     * Styles for the icon element
     * @return {Object}
     */
    iconStyles () {
      const rotation = this.isActive ? -45 : 0

      return {
        transform: `rotate(${rotation}deg)`
      }
    }
  }
}
</script>

<style>
@import 'properties';

.OverlayToggle {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 18px 18px 24px 24px;
  cursor: pointer;
}

.OverlayToggle-icon {
  position: relative;
  top: -1px;
  will-change: transform;
  transform: rotate(0deg);
  transition: transform 0.25s ease;
}

.OverlayToggle-icon svg {
  fill: var(--c-grey-xlt) !important;
}

.OverlayToggle-label {
  margin-right: 6px;
  font-family: var(--font-family-mono);
  line-height: 0;
  font-size: 10px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--c-grey-xlt);
}
</style>



// WEBPACK FOOTER //
// OverlayToggle.vue?40f4f0ec